import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import travel from "../../Assets/Projects/travel.png";
import weather from "../../Assets/Projects/weather.png";
import car from "../../Assets/Projects/car-house.png";
import clock from "../../Assets/Projects/clock.png";
import learn from "../../Assets/Projects/learn.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={car}
              isBlog={false}
              title="Car House"
              description="Users can buy any car and check their previous order history with status.
                This website has a functional admin panel with restricted access.
                Only admin can access this section where admin can 1. add product, 2. delete
                any existing product, 3. update the state of customers order."
              link="https://github.com/afreul-joy/Car-House-12"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={travel}
              isBlog={false}
              title="Traveller's Point"
              description="User booking any place,
              Users can cancel previous orders, check his order & can add packages "
              link="https://github.com/afreul-joy/Traveller-s-Point_11"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={weather}
              isBlog={false}
              title="Weather News"
              description="You Can Check Any Cities Weather From Here"
              link="https://github.com/afreul-joy/Weather-Api"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={learn}
              isBlog={false}
              title="Learn With Joy"
              description="You Can Learn Any Skill From Here. It's Basically Educational Side"
              link="https://github.com/afreul-joy/Learn-With-Joy_09"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={clock}
              isBlog={false}
              title="Digital Clock"
              description="It's Digital Clock Mini Project"
              link="https://github.com/afreul-joy/JS-Clock-"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
